import React from "react";
import PropTypes from "prop-types";
import { useTransition, animated } from "react-spring";
import styles from "./styles.module.css";
import { ReactComponent as TecorienLoader } from "./images/loaderVehicle.svg";


const Loader = React.memo(({ processId }) => {

  const [ immediate, setImmediate ] = React.useState(true);
  React.useEffect(() => {
    setImmediate(true);
    setTimeout(() => {
      setImmediate(false);
    }, 0);
  }, [ setImmediate ]);

  const transitions = useTransition(!!processId, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    immediate,
  });
  return transitions.map(({ item, key, props }) =>
    item && (
      <animated.div key={key} style={props} className={styles.container}>
        <TecorienLoader />
      </animated.div>
    ),
  );
});

Loader.propTypes = {
  classes: PropTypes.object,
  processId: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  description: PropTypes.string,
};

Loader.defaultProps = {
  classes: {},
  processId: undefined,
  description: undefined,
};

export default Loader;
